import { notifications } from "@mantine/notifications"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { useTranslation } from "react-i18next"

import { ContactRequests } from "@tfg/types/endpoints/contacts"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient.ts"

export const useCreateContactMutation = (
  options?: UseMutationOptions<
    number,
    AxiosError,
    ContactRequests.CreateContact
  >
) => {
  const { t } = useTranslation("traceability")

  return useMutation({
    ...options,
    mutationFn: async (variables) =>
      (await httpClient.post<number>("contacts", variables)).data,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(["listContacts"])
      notifications.show({
        message: t("contactModal.messages.success", { email: variables.email }),
        color: "teal",
      })
      options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      notifications.show({
        message: t("contactModal.messages.error", {
          error: error.response?.data ?? error.message,
        }),
        color: "red",
      })
      options?.onError?.(error, variables, context)
    },
  })
}
